import { render } from "./MemberServiceSetting.vue?vue&type=template&id=35571e46&scoped=true"
import script from "./MemberServiceSetting.vue?vue&type=script&lang=js"
export * from "./MemberServiceSetting.vue?vue&type=script&lang=js"

import "./MemberServiceSetting.vue?vue&type=style&index=0&id=35571e46&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35571e46"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/MemberServiceSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35571e46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35571e46', __exports__)) {
    api.reload('35571e46', __exports__)
  }
  
  module.hot.accept("./MemberServiceSetting.vue?vue&type=template&id=35571e46&scoped=true", () => {
    api.rerender('35571e46', render)
  })

}


export default __exports__